import { useQuery } from '@tanstack/react-query';
import { profileService } from '@/services/profile';
import { profileKeys } from './queryKeys';

export const useMyProfile = () => {
  return useQuery({
    queryKey: profileKeys.myProfile(),
    queryFn: profileService.getMyProfile,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false, // Profile is managed by auth flow; changes are infrequent
  });
};
